import React, { useState, useEffect } from "react";

const colors = [
    { name: "Rosso", hex: "#ef4444", rgb: "239, 68, 68" },
    { name: "Blu", hex: "#3b82f6", rgb: "59, 130, 246" },
    { name: "Verde", hex: "#22c55e", rgb: "34, 197, 94" },
    { name: "Giallo", hex: "#facc15", rgb: "250, 204, 21" },
    { name: "Viola", hex: "#a855f7", rgb: "168, 85, 247" },
    { name: "Arancione", hex: "#f97316", rgb: "249, 115, 22" },
    { name: "Ciano", hex: "#06b6d4", rgb: "6, 182, 212" },
    { name: "Rosa", hex: "#ec4899", rgb: "236, 72, 153" }
];

export default function ColorMatch() {
    const [currentColor, setCurrentColor] = useState(null);
    const [options, setOptions] = useState([]);
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(30);
    const [gameActive, setGameActive] = useState(false);
    const [feedback, setFeedback] = useState("");

    const generateQuestion = () => {
        const correct = colors[Math.floor(Math.random() * colors.length)];
        const wrongColors = colors.filter(c => c.name !== correct.name);
        const wrong1 = wrongColors[Math.floor(Math.random() * wrongColors.length)];
        const wrong2 = wrongColors.filter(c => c.name !== wrong1.name)[Math.floor(Math.random() * (wrongColors.length - 1))];

        const opts = [correct, wrong1, wrong2].sort(() => Math.random() - 0.5);

        setCurrentColor(correct);
        setOptions(opts);
        setFeedback("");
    };

    const startGame = () => {
        setScore(0);
        setTimeLeft(30);
        setGameActive(true);
        generateQuestion();
    };

    useEffect(() => {
        if (gameActive && timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && gameActive) {
            setGameActive(false);
        }
    }, [timeLeft, gameActive]);

    const handleAnswer = (selectedColor) => {
        if (selectedColor.name === currentColor.name) {
            setScore(score + 1);
            setFeedback("✓");
            setTimeout(() => generateQuestion(), 500);
        } else {
            setFeedback("✗");
            setTimeout(() => generateQuestion(), 800);
        }
    };

    if (!gameActive && timeLeft > 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-palette" style={{marginRight:"6px"}}></i> Color Match
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Abbina il nome al colore giusto!</p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (timeLeft === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Tempo Scaduto!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    Punteggio: {score}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score >= 20 && "🎨 Hai un occhio da designer!"}
                    {score >= 15 && score < 20 && "👍 Ottima sensibilità cromatica!"}
                    {score >= 10 && score < 15 && "🌈 Buon risultato!"}
                    {score < 10 && "🎨 Continua a esercitarti!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{display:"flex", justifyContent:"space-between", marginBottom:"1.5rem", fontSize:"0.85rem"}}>
                <span style={{color:"#94a3b8"}}>⏱️ {timeLeft}s</span>
                <span style={{color:"#22c55e", fontWeight:"700"}}>🎯 {score}</span>
            </div>

            {currentColor && (
                <>
                    <div style={{
                        fontSize:"1.2rem",
                        fontWeight:"700",
                        marginBottom:"1.5rem",
                        color:"#facc15"
                    }}>
                        Trova: <span style={{color:"#fff"}}>{currentColor.name}</span>
                    </div>

                    <div style={{
                        display:"flex",
                        flexDirection:"column",
                        gap:"1rem",
                        marginBottom:"1rem"
                    }}>
                        {options.map((color, index) => (
                            <button
                                key={index}
                                onClick={() => handleAnswer(color)}
                                style={{
                                    height:"60px",
                                    borderRadius:"0.8rem",
                                    border:"2px solid rgba(255,255,255,0.2)",
                                    background: color.hex,
                                    cursor:"pointer",
                                    transition:"all 0.3s ease",
                                    position:"relative",
                                    overflow:"hidden"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                            >
                                <div style={{
                                    position:"absolute",
                                    top:0, left:0, right:0, bottom:0,
                                    background:"rgba(0,0,0,0.2)",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    fontSize:"0.8rem",
                                    color:"#fff",
                                    fontWeight:"600",
                                    textShadow:"0 2px 4px rgba(0,0,0,0.5)"
                                }}>
                                    RGB: {color.rgb}
                                </div>
                            </button>
                        ))}
                    </div>

                    {feedback && (
                        <div style={{
                            fontSize:"2rem",
                            color: feedback === "✓" ? "#22c55e" : "#ef4444",
                            fontWeight:"700"
                        }}>
                            {feedback}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}